const CUSTOM_EVENT_TYPES = {
	/* Events that indicate where a user is located or interacting physically.
	 Examples might include a check-in, geo fence, or GPS navigation. */
	"location": 2,

	/* Events that indicate a user click sequence or content consumption.
	 Examples might include interface navigation, music listening, video view,
	 menu or tab Selection, or when the back button is pressed. */
	"navigation": 1,

	/* Any event where users input criteria to find content/answers.
	 Examples might include a keyword search, voice search, or a QR code scan. */
	"search": 3,

	/* Any action where users share content with others. Examples might
	include post, rate, tweet, share, attach, email. */
	"social": 7,

	/* Any events that are part of a transaction workflow. Examples
	might include selecting a product, subscribe, upgrade, or bid. */
	"transaction": 4,

	/* Events where users are creating content. Examples might include
	create task, compose, record, scan, or save. */
	"user_content": 5,

	/* Any event that creates personalization for the user. This includes
	registration, saving/labeling content items, creating profiles, setting
	application preferences or permissions. */
	"user_preference": 6,

	/* Use this event type to create an event that falls into no clear
	category. */
	"other": 8,
};

export default CUSTOM_EVENT_TYPES;



// WEBPACK FOOTER //
// ./src/analytics/util/CustomEventTypes.js